export default __webpack_public_path__ + "c7afa122f8475011c6185d526734ab91.png";